import { Anchor, Text, Box } from "grommet";
import { PlainLink } from "../../../../src/components/atomic/TattleLinks";
import { LatestProductBlogsUpdates } from "../../../../src/components/LatestProductBlogsUpdates";
import * as React from 'react';
export default {
  Anchor,
  Text,
  Box,
  PlainLink,
  LatestProductBlogsUpdates,
  React
};